(function($, ns) {
    'use strict';

    var cfg = {
        cache: {
            companyIdField: '#primaryCompanyId',
            formToggle: '[data-target="fill-out-the-form"]',
            hiddenContactId: '.hidden-contact-id,[value="hidden-contact-id"]'
        },
        classes: {},
        data: {
            companyId: 'company-id'
        },
        events: {
            click: 'click'
        },
        options: {}
    };

    ns.FilloutTheFormWffm = function(container) {
        this.container = container;
        this.settings = cfg;
        this.init();
    };

    ns.FilloutTheFormWffm.prototype = {
        init: function() {
            this.cacheItems();
            if (this.container.length) {
                this.bindEvents();
                this.activate();
            }
        },
        cacheItems: function() {
            var cache = this.settings.cache,
                data = this.settings.data;

            this.htmlBody = $('html, body');

            this.companyId = this.container.data(data.companyId);
            this.hiddenContactId = this.container.find(cache.hiddenContactId);

            this.formToggle = this.container.prev().find(cache.formToggle);
            // if (!this.formToggle || !this.formToggle.length) {
            //     this.formToggle = $(cache.formToggle);
            // }
        },
        bindEvents: function() {
            var settings = this.settings,
                events = settings.events;

            this.formToggle.on(events.click, () => {
                this.container.show();
                this.htmlBody.animate(
                    {
                        scrollTop: this.container.offset().top
                    },
                    500
                );
                return false;
            });
        },
        activate: function() {
            let settings = this.settings,
                data = settings.data;

            let companyId = this.container.data(data.companyId);

            this.hiddenContactId.addClass('hidden-contact-id');

            if (this.hiddenContactId.length) {
                for (var i = 0; i < this.hiddenContactId.length; i++) {
                    var hidden = this.hiddenContactId.eq(i);
                    if (hidden.val() === undefined || hidden.val() === '') {
                        hidden.val(companyId);
                    }
                }
            }
        }
    };

    return ns;
})(window.jQuery, window.Dom || {});
